module.exports = __webpack_public_path__ + "img/case2.bdb8ae51.png";